import Icon from '../components/Icon.vue'

Icon.register({
  'share-square': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M568.5 177.4l-144 136c-15.2 14.3-40.5 3.7-40.5-17.4v-72c-144.6 1-205.6 35.1-164.8 171.4 4.5 15-12.8 26.6-25 17.3-39-29.6-74.2-86.2-74.2-143.4 0-143.9 117.6-172.5 264-173.3v-72c0-21.2 25.3-31.8 40.5-17.4l144 136c10 9.5 10 25.4 0 34.9zM384 379.1c0-7.3 6.5-12.9 13.8-11.9 2.8 0.4 7.4 0.7 10.2 0.7 6.8 0 17.5-1.8 24-4.1 7.8-2.8 16 3 16 11.3v88.8c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h121c12.6 0 16.7 16.8 5.5 22.6-18.8 9.8-36.1 22.1-51 37.7-2 2-5.8 3.7-8.6 3.7h-50.9v320h320v-68.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share-square.js
// module id = 1877
// module chunks = 0